export default __webpack_public_path__ + "static/media/area-4.f0ac31d8.png";